import React from 'react'
import { Box, Typography, useTheme } from '@mui/material'
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline'
import CustomButton from '../../../components/CustomButton'
import { useTranslation } from 'react-i18next'
import { isMobile } from '../../../utils/utils'

const DashboardHeader = ({ user, onOpenTutorial }) => {
  const { t } = useTranslation()
  const theme = useTheme()

  const greeting = () => {
    const hour = new Date().getHours()
    if (hour < 12) return t('good_morning') || 'Good morning'
    if (hour < 18) return t('good_afternoon') || 'Good afternoon'
    return t('good_evening') || 'Good evening'
  }

  return (
    <Box
      data-tour="dashboard-header"
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        mb: { xs: 2, sm: 3 },
        flexWrap: 'wrap',
        gap: 2,
      }}
    >
      <Box>
        <Typography
          variant="h4"
          sx={{
            fontFamily: theme.typography.h1.fontFamily,
            fontWeight: 300,
            fontSize: { xs: '1.5rem', sm: '1.85rem' },
            color: theme.palette.text.primary,
            letterSpacing: '-0.02em',
            lineHeight: 1.2,
          }}
        >
          {greeting()}, {user?.first_name || ''}
        </Typography>
        <Typography
          variant="body2"
          sx={{
            color: theme.palette.text.secondary,
            mt: 0.75,
            fontSize: '0.875rem',
          }}
        >
          {t('dashboard_subtitle') || "Here's what's happening with your legal data today."}
        </Typography>
      </Box>

      <Box sx={{ display: 'flex', gap: 1.5, alignItems: 'center', flexShrink: 0 }}>
        <CustomButton
          text={isMobile() ? t('video') : t('tutorial_video')}
          outlined={true}
          startIcon={<PlayCircleOutlineIcon />}
          onClick={onOpenTutorial}
          title={t('tutorial_video')}
          sx={{
            borderRadius: 1,
            textTransform: 'none',
            fontWeight: 500,
            fontSize: '0.875rem',
            px: { xs: 1.5, sm: 2 },
          }}
        />
      </Box>
    </Box>
  )
}

export default DashboardHeader
